import React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import LinkedItem from '../../../../LinkedItem/index';
import LoadingSpin from '../../../../../LoadingSpin';

import styles from '../links.less';
import controlStyles from '../../controls.less';

const ListItem = (props) => {
  const { item, onRemoveItem, onRestoreItem, params, sceneId, editable, apiOnly } = props;
  const { t } = useTranslation();

  const itemRemovableProperty = item.getIn(['item', 'removable']);
  const canRestore = item.get('canRestore');
  const itemData = item.get('item');
  const removed = itemData && itemData.get('isRemoved');
  // Если нет этого пропса то в лоадинг
  if (canRestore) {
    return (
      <LinkedItem
        key={item.get('key')}
        removable={itemRemovableProperty === false ? itemRemovableProperty : editable && !apiOnly}
        title={t('record.fields.object.restore')}
        item={{
          icon: 'transfers-70',
          text: item.get('text') || t('record.newRecordCreating'),
        }}
        sceneId={sceneId}
        className={props.className}
        classNameItem={cn(props.classNameItem, controlStyles.restoreItemText)}
        classNameColor={controlStyles.restoreItemColor}
        classNameItemColor={controlStyles.restoreItemColor}
        onClickRemove={() => onRemoveItem && onRemoveItem(item)}
        onClick={onRestoreItem}
      />
    );
  }
  return (
    <LinkedItem
      key={item.get('key')}
      removed={removed}
      sceneId={sceneId}
      removable={itemRemovableProperty === false ? itemRemovableProperty : editable && !apiOnly}
      item={
        !item.get('text')
          ? {
              icon: <LoadingSpin />,
              text: t('loadingText'),
            }
          : item.toJS()
      }
      className={props.className}
      classNameItem={props.classNameItem}
      onClickRemove={() => onRemoveItem && onRemoveItem(item)}
      params={params}
    />
  );
};

export default ListItem;
